import { render } from "./Grade.vue?vue&type=template&id=0de1d464"
import script from "./Grade.vue?vue&type=script&lang=ts"
export * from "./Grade.vue?vue&type=script&lang=ts"

import "./Grade.vue?vue&type=style&index=0&id=0de1d464&lang=css"
script.render = render

export default script